import { Route, Ban, Construction, ParkingCircleOff, Check, X, Undo2, Waypoints, ArrowLeftRight, Ruler } from "lucide-react";
import { KINDS } from "@/lib/constants";
import { SIGNS } from "@/components/map/SignObjects";
import { ObjectsMenu } from "@/components/map/ObjectsMenu";

const TOOLS = [
  { kind: "route", icon: Route, testid: "map-draw-route-button" },
  { kind: "cut_point", icon: Ban, testid: "map-add-cut-point-marker-button" },
  { kind: "street_cut", icon: Construction, testid: "map-draw-cut-polyline-button" },
  { kind: "no_parking", icon: ParkingCircleOff, testid: "map-draw-no-parking-polygon-button" },
  { kind: "special_path", icon: Waypoints, testid: "map-draw-special-path-button" },
  { kind: "reversed_oneway", icon: ArrowLeftRight, testid: "map-draw-reversed-oneway-button" },
];

const LINE_META = { label: "Línea de vallas", hint: "Pulse puntos a lo largo del recorrido de las vallas y pulse Terminar. El número se calcula según la separación." };

export const MeasureButton = ({ active, onClick }) => (
  <button onClick={onClick} data-testid="map-measure-button" title="Medir distancia"
    className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium border backdrop-blur-md transition-colors ${active ? "bg-sky-500 text-slate-950 border-sky-400" : "bg-[#090f20]/90 text-slate-300 border-white/10 hover:bg-white/10"}`}>
    <Ruler className="w-4 h-4" /> Medir
  </button>
);

export const DrawToolbar = ({ mode, setMode, draft, onFinish, onCancel, onUndo }) => (
  <div className="absolute top-3 left-14 right-48 z-[500] flex flex-col items-start gap-2 pointer-events-none">
    <div className="flex flex-wrap gap-1 bg-[#090f20]/90 backdrop-blur-md border border-white/10 rounded-xl p-1 pointer-events-auto" data-testid="map-draw-toolbar">
      {TOOLS.map(({ kind, icon: Icon, testid }) => (
        <button key={kind} data-testid={testid} title={KINDS[kind].label}
          onClick={() => setMode(mode === kind ? null : kind)}
          className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-colors ${mode === kind ? "bg-sky-500 text-slate-950" : "text-slate-300 hover:bg-white/10"}`}>
          <Icon className="w-4 h-4" style={{ color: mode === kind ? undefined : KINDS[kind].color }} />
          <span className="hidden xl:inline">{KINDS[kind].short}</span>
        </button>
      ))}
      <span className="w-px bg-white/10 mx-0.5" />
      <ObjectsMenu mode={mode} setMode={setMode} />
    </div>
    {mode?.startsWith("sign:") && (
      <div className="bg-[#090f20]/95 backdrop-blur-md border border-amber-400/40 rounded-xl p-3 max-w-xs pointer-events-auto rise flex items-start gap-3" data-testid="map-sign-hint">
        <div><div className="text-xs text-amber-300 font-semibold mb-1">{SIGNS[mode.slice(5)].label}</div><div className="text-xs text-slate-400">{KINDS.sign.hint}</div></div>
        <button onClick={onCancel} data-testid="map-sign-cancel-button" className="px-2 py-1.5 rounded-md bg-white/10 text-xs"><X className="w-3.5 h-3.5" /></button>
      </div>
    )}
    {mode && (KINDS[mode] || mode === "sign_line") && (
      <div className="bg-[#090f20]/95 backdrop-blur-md border border-sky-500/40 rounded-xl p-3 max-w-xs pointer-events-auto rise" data-testid="map-draw-hint">
        <div className="text-xs text-sky-300 font-semibold mb-1">{(KINDS[mode] || LINE_META).label}</div>
        <div className="text-xs text-slate-400">{(KINDS[mode] || LINE_META).hint}</div>
        {mode !== "cut_point" && (
          <div className="flex gap-2 mt-3">
            <button onClick={onFinish} disabled={draft.length < (mode === "no_parking" ? 3 : 2)} data-testid="map-draw-finish-button"
              className="flex items-center gap-1 px-3 py-1.5 rounded-md bg-emerald-500 text-slate-950 text-xs font-semibold disabled:opacity-40">
              <Check className="w-3.5 h-3.5" /> Terminar ({draft.length})
            </button>
            <button onClick={onUndo} disabled={!draft.length} data-testid="map-draw-undo-button" className="px-2 py-1.5 rounded-md bg-white/10 text-xs disabled:opacity-40"><Undo2 className="w-3.5 h-3.5" /></button>
            <button onClick={onCancel} data-testid="map-draw-cancel-button" className="px-2 py-1.5 rounded-md bg-white/10 text-xs"><X className="w-3.5 h-3.5" /></button>
          </div>
        )}
      </div>
    )}
  </div>
);
